export var ErrorAppearance;
(function (ErrorAppearance) {
    ErrorAppearance["TextOnly"] = "TextOnly";
    ErrorAppearance["BackgroundAndBorder"] = "BackgroundAndBorder";
})(ErrorAppearance || (ErrorAppearance = {}));
export var ErrorMessageWrapperDataHooks;
(function (ErrorMessageWrapperDataHooks) {
    ErrorMessageWrapperDataHooks["Message"] = "errormessagewrapper-message";
})(ErrorMessageWrapperDataHooks || (ErrorMessageWrapperDataHooks = {}));
//# sourceMappingURL=types.js.map